// extracted by mini-css-extract-plugin
export var messageSideLeft = "_s9-1";
export var stateContainer = "_s9-0";